<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte'
  import { getCategories } from '../../persistence'
  import { db } from '../../db'
  import { imagesCache } from '../../caches'
  import { syncCount } from '../../stores'
  import { dataFetch, options } from '../../api'

  const dispatch = createEventDispatcher()
  const controller = new AbortController()

  const disableImagePrefetch = import.meta.env.VITE_DISABLE_IMAGE_PREFETCH === 'true'

  const fetchCategories = async () => {
    const latest = await db.categories.orderBy('updated_at').reverse().first()
    const updatedSince = latest?.updated_at ? new Date(latest.updated_at) : undefined
    return fetchCategoriesSince(1, updatedSince)
  }

  const fetchCategoriesSince = async (page, updatedSince) => {
    const params = {}
    if (updatedSince) {
      params.updated_since = updatedSince.toISOString()
    } else {
      params.updated_since = new Date(0).toISOString()
    }

    const { categories = [], pagination = {}, error } = await getCategories(page, params, true, controller)

    if (error || controller.signal.aborted) return false

    await db.categories.bulkPut(categories)

    if (controller.signal.aborted) return false

    if (pagination.next) {
      return fetchCategoriesSince(pagination.next, updatedSince)
    }

    return true
  }

  const fetchCategoryImages = async () => {
    if (disableImagePrefetch) return true

    const cache = await imagesCache()

    const categories = await db.categories.toArray()
    for (const category of categories) {
      if (controller.signal.aborted) return false

      if (category.image_url) {
        const response = await cache.match(category.image_url)
        if (!response) {
          await dataFetch(category.image_url, {
            showErrorMessage: false,
            fetchOptions: options(false, false),
            controller,
          })
          if (controller.signal.aborted) return false
        }
      }
    }

    return true
  }

  onDestroy(() => controller.abort())

  onMount(async () => {
    try {
      syncCount.update(count => count + 1)
      if ((await fetchCategories()) && (await fetchCategoryImages())) dispatch('success')
    } finally {
      syncCount.update(count => count - 1)
    }
  })
</script>
